import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { IconButton, Paper, Skeleton, SvgIcon, useTheme } from '@mui/material';
import { Download01 } from '../../../../assets';
import CustomPagination from '../../../../components/forms/Pagination';
import { columnsMap } from './FinanceTableColumns';
import { FinanceTableRowModel } from '../../../../app/services/api/orderManagementClient';

interface FinanceTableProps {
  data: FinanceTableRowModel[];
  tableType: 'invoices' | 'creditNotes' | 'statements' | 'rebates' | 'loyalty';
  page: number;
  setPage: (page: number) => void;
  totalPages: number;
  isLoading: boolean;
  onDocumentDownload: (documentId: number) => Promise<void>;
}

const FinanceTable = ({ data, tableType, page, setPage, totalPages, isLoading, onDocumentDownload }: FinanceTableProps) => {
  const { t } = useTranslation('finance');
  const theme = useTheme();
  const columns = columnsMap[tableType];

  return (
    <TableContainer sx={{ borderRadius: '12px' }}
      component={Paper}>
      {isLoading
        ?
        <Skeleton sx={{ bgcolor: theme.palette.custom.gray[100] }}
          variant='rectangular'
          height={445.89}
        />
        :
        <><Table size="small"
          aria-label="finance table">
          <TableHead sx={{ backgroundColor: theme.palette.custom.gray[200] }}>
            <TableRow>
              {columns.map(col => (
                <TableCell key={col.key}>{t(col.key)}</TableCell>
              ))}
              <TableCell align="right">{t('actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, idx) => (
              <TableRow key={idx}>
                {columns.map(col => (
                  <TableCell key={col.key}>{row[col.key as keyof typeof row] ?? '-'}</TableCell>
                ))}
                <TableCell align="right">
                  <IconButton size="small"
                    aria-label="download"
                    onClick={() => onDocumentDownload(row.id)}>
                    <SvgIcon fontSize="small"><Download01 /></SvgIcon>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table><CustomPagination
          page={page}
          setPage={setPage}
          maxPages={totalPages}
          breakpointForChangeDisplay={120000} /></>
      }
    </TableContainer>
  );
};

export default FinanceTable;
